export class UsunSrodekModel {
    idProjektu: string;
    idLokalizacji: string;
    idPomieszczenia: string;
    id: string;
}